export const deleteItemInLimitNotify = (roomId: string) => {
    let limitNotify: any = localStorage.getItem('limitNotify');
    try {
        limitNotify = JSON.parse(limitNotify);
    } catch (error) {
        limitNotify = [];
    }
    const filterLimitNotify = limitNotify?.filter((notify: any) => notify.roomId !== roomId);
    if (filterLimitNotify) {
        localStorage.setItem('limitNotify', JSON.stringify(filterLimitNotify));
    }
};
